import React from "react";
import { BrowserRouter as Router, Routes, Route, Link, Navigate } from "react-router-dom";
import { Analytics } from "@vercel/analytics/react";
import "./App.css";
import Writings from "./components/blog/Writings";
import Person from "./components/blog/Person";
import Stanford from "./components/blog/Stanford";
import Simulation from "./components/blog/Simulation";
import Logging from "./components/blog/Logging";

const Home = () => {
  return (
    <div className="app">
      <Analytics />
      <div className="container">
        <div className="content">
          <div className="header-row">
            <h1>max lee</h1>
            <Link to="/writings" className="blog-link">writings</Link>
          </div>
          <p>maxleedev@berkeley.edu | <a href="https://linkedin.com/in/max-lee-dev" target="_blank" rel="noopener noreferrer">linkedin</a> | <a href="https://github.com/max-lee-dev" target="_blank" rel="noopener noreferrer">github</a> | <a href="https://x.com/maxleedev" target="_blank" rel="noopener noreferrer">x</a> </p>

          <p>19 y/o life <Link to="/writings/logging">logger</Link></p>

          <h2>experience</h2>

          <p><a href="https://x.com/eddybuild" target="_blank" rel="noopener noreferrer">build.ai</a> (2025) -  backed by abstract ventures, pear vc, hf0, zfellows, alex botez and other great partners. helped solve robotics as founding eng</p>

          <p><a href="https://findecs.org" target="_blank" rel="noopener noreferrer">findecs.org</a> (2023-2024) - sold an edtech startup with 178k users in 3 months. turned $180 {'->'} 5m+ views using node + puppeteer instagram web scraping.</p>

          <p><a href="https://interaction.co" target="_blank" rel="noopener noreferrer">interaction.co</a> (2025) - engineered vc backed ai email client (poke) integrating iMessage {'->'} google workspace functions. learned to make good ui :)</p>



          <h2>projects</h2>

          <p><a href="https://x.com/maxleedev/status/1962938769914658984" target="_blank" rel="noopener noreferrer">lmcanvas.ai</a> - 16k likes and 2M+ views on X, received DMs from OpenAI, Thinking Machines, and xAI. canvas-style LLM chat interface allowing for branching queries, 4k+ on waitlist</p>

          <p><a href="https://essayswap.org" target="_blank" rel="noopener noreferrer">essayswap.org</a> / <a href="https://resume.reviews" target="_blank" rel="noopener noreferrer">resume.reviews</a> - peer-to-peer essay/resume review platform created as 17 y/o. next.js, stripe, firebase. 1000+ essays/resumes, 800+ users. real-time chat system.</p>

          <p><a href="https://hackertype.dev" target="_blank" rel="noopener noreferrer">hackertype</a> - coding typing test created as 15 y/o. 4k+ users, 30k+ submissions. react, firebase, auth, live leaderboard.</p>

          <p>
            <span style={{ textDecoration: "underline" }}>sleepscore</span> - swiftui mobile app with healthkit integration created as 16 y/o. realtime leaderboard for sleep habits.
          </p>


        </div>
      </div>
    </div>
  );
};

const App = () => {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/writings" element={<Writings />} />
        <Route path="/writings/person" element={<Person />} />
        <Route path="/writings/stanford" element={<Stanford />} />
        <Route path="/writings/simulation" element={<Simulation />} />
        <Route path="/writings/logging" element={<Logging />} />
        <Route path="/blog/*" element={<Navigate to="/writings" replace />} />
      </Routes>
    </Router>
  );
};

export default App;
